/**
 * Appends the product's own value to a (still mocked) option list when it isn't already in it, so a live
 * vendor/form from the BFF stays selectable.
 * @param options The fixed option list.
 * @param extra The value that must be selectable, if any.
 * @returns {readonly string[]} `options`, plus `extra` when missing.
 */
export function withOption(options: readonly string[], extra?: string | null): readonly string[] {
  return extra && !options.includes(extra) ? [...options, extra] : options;
}
